import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Box, Collapse, Grid, Typography } from "@mui/material"
import { useState } from "react"

const QuestionAnswer = ({ question, answer }) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <Grid item xs={12} lg={6}>
            <Box
                sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    background: "rgba(255,255,255,0.9)",
                    border: "1px solid rgba(0, 4, 53, 0.08)",
                    boxShadow: expanded
                        ? "0 12px 32px rgba(0, 4, 53, 0.08)"
                        : "0 8px 24px rgba(0, 4, 53, 0.04)",
                    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
                    "&:hover": {
                        borderColor: "rgba(0, 163, 255, 0.35)",
                    },
                }}
            >
                <Box
                    component="button"
                    type="button"
                    onClick={() => setExpanded((prev) => !prev)}
                    aria-expanded={expanded}
                    aria-label={expanded ? "Collapse answer" : "Expand answer"}
                    sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1.5,
                        p: { xs: 1.75, sm: 2 },
                        border: 0,
                        background: "transparent",
                        cursor: "pointer",
                        textAlign: "left",
                        color: "inherit",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        color="#000435"
                        lineHeight={1.35}
                    >
                        {question}
                    </Typography>
                    <Box
                        component="span"
                        aria-hidden
                        sx={{
                            flexShrink: 0,
                            display: "grid",
                            placeItems: "center",
                            width: 32,
                            height: 32,
                            borderRadius: "50%",
                            bgcolor: expanded ? "rgba(0, 163, 255, 0.12)" : "rgba(0, 4, 53, 0.05)",
                            color: expanded ? "#00A3FF" : "#000435",
                        }}
                    >
                        {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                    </Box>
                </Box>

                <Collapse in={expanded}>
                    <Box
                        sx={{
                            px: { xs: 1.75, sm: 2 },
                            pb: { xs: 1.75, sm: 2 },
                            pt: 0,
                            borderTop: "1px solid rgba(0, 4, 53, 0.06)",
                        }}
                    >
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            lineHeight={1.75}
                            sx={{ pt: 1.5 }}
                        >
                            {answer}
                        </Typography>
                    </Box>
                </Collapse>
            </Box>
        </Grid>
    )
}

export default QuestionAnswer
